import React from 'react'

import { Col, Row } from '@/shared/ui/Grid'

import { ProductSpecItem } from './components/ProductSpecItem/ProductSpecItem'

import cl from './product-specs.module.scss'

export type TechSpecsTabProps = {
	items: { name: string; value: string; link?: string }[]
}

export const ProductSpecs = ({ items }: TechSpecsTabProps): JSX.Element => {
	return (
		<section className={cl.productSpecs}>
			<Row>
				<Col xs={24}>
					<section className={cl.productSpecs_group}>
						{items?.map(({ name, value, link }) => (
							<ProductSpecItem name={name} value={value} key={name + value} link={link} />
						))}
					</section>
				</Col>
			</Row>
		</section>
	)
}
